export default "__VITE_ASSET__gO6J8GcT__"